var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 1.5,
    fill: "white",
    stroke: "#E4C043"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.004 14.9963C8.90116 14.9963 8.00391 14.0989 8.00391 12.996C8.00391 11.8931 8.90116 10.9961 10.004 10.9961C11.1069 10.9961 12.0041 11.8931 12.0041 12.996C12.0041 14.0989 11.1067 14.9963 10.004 14.9963ZM10.004 11.6628C9.26893 11.6628 8.67061 12.2613 8.67061 12.9963C8.67061 13.7315 9.26868 14.3297 10.004 14.3297C10.7391 14.3297 11.3374 13.7316 11.3374 12.9963C11.3372 12.2612 10.7392 11.6628 10.004 11.6628Z",
    fill: "#E4C043",
    stroke: "#E4C043",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16805 10.3295C8.98418 10.3295 8.83471 10.1802 8.83471 9.99617V5.16282C8.83471 4.88721 8.6103 4.6628 8.33468 4.6628C8.05907 4.6628 7.83466 4.88721 7.83466 5.16282V9.99617C7.83466 10.1802 7.68539 10.3295 7.50132 10.3295C7.31724 10.3295 7.16797 10.1802 7.16797 9.99617V5.16282C7.16797 4.51945 7.69133 3.99609 8.3347 3.99609C8.97807 3.99609 9.50143 4.51945 9.50143 5.16282V9.99617C9.50143 10.1802 9.35216 10.3295 9.16808 10.3295H9.16805Z",
    fill: "#E4C043",
    stroke: "#E4C043",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8321 9.33342C10.648 9.33342 10.4988 9.18415 10.4988 9.00008V4.16653C10.4988 3.89091 10.2746 3.66651 9.99875 3.66651C9.72313 3.66651 9.49873 3.89072 9.49873 4.16653V9.00008C9.49873 9.18415 9.34945 9.33342 9.16538 9.33342C8.9815 9.33342 8.83203 9.18415 8.83203 9.00008V4.16653C8.83203 3.52336 9.35539 3 9.99856 3C10.6419 3 11.1653 3.52336 11.1653 4.16653V9.00008C11.1653 9.18395 11.0162 9.33342 10.8321 9.33342H10.8321Z",
    fill: "#E4C043",
    stroke: "#E4C043",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4962 10.3295C12.3121 10.3295 12.1628 10.1802 12.1628 9.99617V5.16282C12.1628 4.88721 11.9384 4.6628 11.6628 4.6628C11.387 4.6628 11.1628 4.88721 11.1628 5.16282V9.99617C11.1628 10.1802 11.0137 10.3295 10.8294 10.3295C10.6454 10.3295 10.4961 10.1802 10.4961 9.99617V5.16282C10.4961 4.51945 11.0197 3.99609 11.6628 3.99609C12.306 3.99609 12.8294 4.51945 12.8294 5.16282V9.99617C12.8296 10.1802 12.6803 10.3295 12.4962 10.3295H12.4962Z",
    fill: "#E4C043",
    stroke: "#E4C043",
    strokeWidth: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 16.9987C7.51869 16.9987 5.5 14.9798 5.5 12.4987V6.49876C5.5 5.85539 6.02336 5.33203 6.66653 5.33203C7.3099 5.33203 7.83306 5.85539 7.83306 6.49876V10.3321C7.83306 10.5161 7.68378 10.6654 7.49971 10.6654C7.31564 10.6654 7.16636 10.5161 7.16636 10.3321V6.49876C7.16636 6.22315 6.94215 5.99874 6.66654 5.99874C6.39073 5.99874 6.16671 6.22315 6.16671 6.49876V12.4987C6.16671 14.6125 7.88647 16.332 10 16.332C12.1138 16.332 13.8333 14.6124 13.8333 12.4987V7.49867C13.8333 7.22305 13.6091 6.99864 13.3333 6.99864C13.0575 6.99864 12.8334 7.22305 12.8334 7.49867V10.3321C12.8334 10.5162 12.6842 10.6655 12.5001 10.6655C12.316 10.6655 12.1668 10.5162 12.1668 10.3321V7.49867C12.1668 6.8553 12.6901 6.33214 13.3333 6.33214C13.9767 6.33214 14.4998 6.8555 14.4998 7.49867V12.4987C14.4998 14.9798 12.4811 16.9987 10 16.9987H9.99999Z",
    fill: "#E4C043",
    stroke: "#E4C043",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJain);
export default __webpack_public_path__ + "static/media/jain.f215120fd65dfca1daa6e37366be81db.svg";
export { ForwardRef as ReactComponent };